import { defineStore } from 'pinia';
import useApi from '@/composeables/useApi';
import { County, Sector } from '@/constants/types/api';

export const useFilterStore = defineStore('filterStore', {
  state: () => ({
    countiesList: [] as County[],
    sectorsList: [] as Sector[],
  }),
  actions: {
    async fetchFilters() {
      const { apiGet } = useApi();
      const res = await apiGet<any>('/filters');
      if (res) {
        this.countiesList = res.counties;
        this.sectorsList = res.sectors;
      }
    },
  },
  getters: {
    counties: (state) => (includeAll = false): County[] => {
      if (includeAll) {
        return state.countiesList;
      }
      return state.countiesList.filter((f) => f.id !== 41);
    },
    sectors: (state) => (includeAll = false): Sector[] => {
      if (includeAll) {
        return state.sectorsList;
      }
      return state.sectorsList.filter((f)=> f.id !== 42);
    },
  },
});
